import { ReactNode } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@Utils';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@Components';

interface ToggleCardProps {
  selected: boolean;
  onToggle?: () => void;
  children: ReactNode;
  className?: string;
  readOnly?: boolean;
  multiple?: boolean;
  tooltip?: string;
}

const ToggleCard = ({
  selected,
  onToggle,
  children,
  className,
  readOnly = false,
  multiple = false,
  tooltip,
}: ToggleCardProps) => {
  const cardContent = (
    <div
      className={cn(
        'rounded-lg toggle-card group cursor-pointer p-3.5 transition-all duration-300 border border-solid ',
        selected ? ' border-brand-300 bg-brand-50 text-brand-900' : 'border-gray-300 text-gray-700',
        readOnly ? 'cursor-default' : 'hover:border-gray-700',
        className,
      )}
      onClick={readOnly ? undefined : onToggle}>
      <div className="flex items-start">
        <div
          className={cn(
            'border-solid flex items-center justify-center h-3.5 w-3.5 border-[1.5px] transition-all mr-2',
            multiple ? 'square' : 'rounded-full',
            selected ? 'border-primary text-primary' : 'border-gray-700 bg-white',
          )}>
          {selected && <Check strokeWidth={3} size={12} />}
        </div>
        <div className="flex-1">{children}</div>
      </div>
    </div>
  );

  if (tooltip) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>{cardContent}</TooltipTrigger>
          <TooltipContent>
            <p>{tooltip}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return cardContent;
};

export default ToggleCard;
